export const binarySearchClosest = <T,>(array: {
  [key: number]: T;
}, targetValue: number, getValue: (item: T) => number): number => {
  const totalElements = Object.keys(array).length;
  if (totalElements === 0) {
    return 0;
  }
  let low = 0;
  let high = totalElements - 1;
  while (low < high) {
    const mid = Math.floor((low + high) / 2);
    const midElement = array[mid];
    const midValue = midElement !== undefined ? getValue(midElement) : undefined;
    if (midValue !== undefined && midValue < targetValue) {
      low = mid + 1;
    } else {
      high = mid;
    }
  }
  if (low === 0) {
    return 0;
  }
  const prevElement = array[low - 1];
  const currElement = array[low];
  const prevValue = prevElement !== undefined ? getValue(prevElement) : 0;
  const currValue = currElement !== undefined ? getValue(currElement) : 0;
  const prevDiff = Math.abs(prevValue - targetValue);
  const currDiff = Math.abs(currValue - targetValue);
  return prevDiff <= currDiff ? low - 1 : low;
};